export const weekDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
export const timesOfTheDay = ['WholeDay', 'Morning', 'Afternoon'];

const useWeekDays = () => {};

export default useWeekDays;
